import { Card, Grid, Divider, CardHeader, CardContent } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { MilestoneAccordionMonthList } from '../../components/accordion/milestone-accordion-month-list';
import { useMilestonesToBeBilled } from '../../hooks/useMilestonesToBeBilled';
import { SelectedMilestonesPanel } from '../selected-milestone-panel';
import { useState, useEffect, useCallback } from 'react';
import { MilestonesToBeBilledQueryParams } from '@/services/billing/billing.service';
import { MilestoneSelectorFilterSection } from '../milestone-selector-filter';

interface MilestoneSelectorProps {
  organizationId: string;
}

export const MilestoneSelectorSection = ({ organizationId }: MilestoneSelectorProps) => {
  const [filters, setFilters] = useState<MilestonesToBeBilledQueryParams>({
    organizationId,
    month: undefined,
    year: undefined,
    status: undefined,
    search: undefined,
  });
  const { t } = useTranslation();

  const { groupedMilestones } = useMilestonesToBeBilled(filters);

  const handleChangeFilters = useCallback(
    (filterAttrName: keyof MilestonesToBeBilledQueryParams, value: string) => {
      setFilters((prev) => ({
        ...prev,
        [filterAttrName]: value,
      }));
    },
    []
  );

  useEffect(() => {
    setFilters((prev) => ({
      ...prev,
      organizationId,
    }));
  }, [organizationId]);

  return (
    <Card>
      <CardHeader title={t('Select the milestone you want to bill')} />
      <CardContent>
        <MilestoneSelectorFilterSection
          filters={filters}
          handleChangeFilters={handleChangeFilters}
        />

        <Divider sx={{ mb: 2 }} />

        <Grid container spacing={2}>
          {/* Left Grid */}
          <Grid item xs={12} md={8} sx={{ maxHeight: 'calc(100vh - 30rem)', overflowY: 'auto' }}>
            {groupedMilestones.map((milestones) => (
              <MilestoneAccordionMonthList
                key={milestones.yearMonth}
                groupedMilestones={milestones}
              />
            ))}
          </Grid>

          {/* Right Grid */}
          <Grid item xs={12} md={4} sx={{ maxHeight: 'calc(100vh - 30rem)', overflowY: 'auto' }}>
            <SelectedMilestonesPanel />
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};
